var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiRsShieldExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8343_103705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 14.9996H11.0002V4.99956H13.0002V14.9996ZM12.7932 23.7076C14.9532 22.8396 22.0002 19.4276 22.0002 11.9906V5.46656C22.0004 4.83699 21.802 4.22339 21.4332 3.71313C21.0644 3.20287 20.5441 2.82194 19.9462 2.62456L12.0002 -0.010437L4.05424 2.62456C3.4564 2.82194 2.93606 3.20287 2.56728 3.71313C2.19849 4.22339 2.00007 4.83699 2.00024 5.46656V11.9906C2.00024 18.5536 9.00524 22.5666 11.1532 23.6416L11.9532 24.0416L12.7932 23.7076ZM19.3162 4.52256C19.5146 4.58864 19.6873 4.71525 19.81 4.88458C19.9327 5.05392 19.9992 5.25745 20.0002 5.46656V11.9906C20.0002 18.1736 13.9132 21.1026 12.0472 21.8526C10.1592 20.9076 4.00024 17.4066 4.00024 11.9906V5.46656C4.00124 5.25745 4.06776 5.05392 4.19046 4.88458C4.31315 4.71525 4.48585 4.58864 4.68424 4.52256L12.0002 2.09956L19.3162 4.52256ZM13.0002 16.9996H11.0002V18.9996H13.0002V16.9996Z",
    fill: "#1D1D1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8343_103705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRsShieldExclamation);
export default __webpack_public_path__ + "static/media/fi-rs-shield-exclamation.fbf3f982e07f6481d6e02e9a1879a30c.svg";
export { ForwardRef as ReactComponent };